export default __webpack_public_path__ + "bcae188f9b05a0ae559740a6b836c69c.woff";